/* EvolvingRibbon — small pill that reminds visitors the library is growing.
   Used on Home + Languages pages to communicate the "no game is set in stone"
   promise without cluttering the design. */
import React from 'react';
import { Sparkles } from 'lucide-react';

export default function EvolvingRibbon({ className = '' }) {
    return (
        <div
            data-testid="evolving-ribbon"
            className={`inline-flex items-center gap-2 bg-lq-peach-100 border border-lq-peach-300 text-lq-ink-900 text-xs font-semibold px-3 py-1.5 rounded-full ${className}`}
        >
            <Sparkles size={14} className="text-lq-peach-600" />
            New puzzles, themes and languages ship continuously — tell us what to add next
        </div>
    );
}
